import Avatar from '../Utility/Avatar';
import { useSelector } from 'react-redux';
import { RootState } from '../../Store/Reducers';
import useGlobals from '../../Hooks/useGlobals';
import { ChatMessageRole } from '../../Types/Enums';
import CheckIcon from './CheckIcon';

interface AdminViewCardProps {
    identifier: string;
    handleChangeFunction: any;
    title: string;
    isActive: boolean;
    image?: any;
    useAvatar?: boolean;
}

export default function AdminViewCard({
    identifier,
    title,
    isActive,
    image,
    handleChangeFunction,
    useAvatar = false,
}: AdminViewCardProps) {
    const windowWidth = useSelector((state: RootState) => state.environment.windowWidth);
    const getBreakpoint = useGlobals().getBreakpoint;
    return (
        <div
            className={`relative border-[2px] overflow-hidden rounded-xl cursor-pointer text-center hover:border-primary transition-all duration-150 ${
                isActive ? 'border-primary' : 'border-layout-borderColor'
            }`}
            onClick={() => handleChangeFunction(identifier)}
        >
            {image && !useAvatar ? (
                <div className="bg-white h-1/2 py-2 flex items-center justify-center">
                    <img
                        src={image}
                        className="max-h-[30px] max-w-[60px] md:max-h-[50px] md:max-w-[100px]"
                        alt={title}
                    />
                </div>
            ) : (
                <div className="bg-white h-1/2 p-2 flex items-center justify-center">
                    <div className="w-[30px] h-[30px] md:w-[50px] md:h-[50px] relative">
                        <Avatar
                            role={ChatMessageRole.assistant}
                            size={windowWidth < getBreakpoint('md') ? 30 : 50}
                            avatarImage={image}
                            title={title}
                        />
                    </div>
                </div>
            )}
            <div className="h-1/2 p-2 md:p-4 flex grow justify-center items-center">
                <p className="p-0 h-[32px] md:h-[48px] m-0  text-layout-textcolor text-wrap break-words w-full line-clamp-2">
                    {title}
                </p>
            </div>

            {isActive && <CheckIcon />}
        </div>
    );
}
